export const OVERSEAS_PROVIDER_FILTER = [
  {
    noInitialDisp: null,
    featureGroup: 'ホテル設備・サービス',
    featureGroupId: 1,
    features: [
      {
        noCutShortOver: null,
        object: 'hotel',
        searchAsis: 1,
        nfeature: 'カード利用可',
        ksearchKey: 'f_squeezes',
        ksearchValue: 'credit',
        secondFeatures: [],
      },
      {
        noCutShortOver: null,
        object: 'hotel',
        searchAsis: 1,
        nfeature: 'フィットネスクラブ',
        ksearchKey: 'f_squeezes',
        ksearchValue: 'fitness',
        secondFeatures: [],
      },
      {
        noCutShortOver: null,
        object: 'hotel',
        searchAsis: 1,
        nfeature: 'ビジネスセンター',
        ksearchKey: 'f_squeezes',
        ksearchValue: 'business',
        secondFeatures: [],
      },
      {
        noCutShortOver: null,
        object: 'hotel',
        searchAsis: 1,
        nfeature: '無料シャトルバス',
        ksearchKey: 'f_squeezes',
        ksearchValue: 'shuttlebus',
        secondFeatures: [],
      },
      {
        noCutShortOver: null,
        object: 'hotel',
        searchAsis: 1,
        nfeature: '送迎バス',
        ksearchKey: 'f_squeezes',
        ksearchValue: 'pickupbus',
        secondFeatures: [],
      },
    ],
  },
];
